import React, { memo, useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { createSelector } from 'reselect';
import styles from './SoftCardSearch.module.less';

import { logging, logPostInfo } from '../../actions/log';
import { CONTEXT } from '../../config';
import Button from '../Button/Button';
import ApkButton from '../Button/Button';
import { formatMoney, getSoftType } from '../../utils/utils';

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);

export default memo(({ soft, logInfo, lenovoWords, firstapp }) => {
  const history = useHistory();
  const upgradeSofts = useSelector(selectUpgradeSofts); // 可更新
  const installedSofts = useSelector(selectInstalledSoft); // 已经安装
  const dispatch = useDispatch();
  const [mouseOver, setMouseOver] = useState(0);

  // 1. 联系词softcard 做特殊处理 (即：将其作为搜索结果点击进入详情处理)
  // 首位应用进入详情页面的时候，重置两次logPostInfo（即：让source，source_p，source_p后移一步，logInfo.source = 'Search'）
  // 详情页中通过source_p==='Search'判断来源是否来自搜索
  const handleSoftCard = useCallback(() => {
    dispatch(
      logging({
        category: 'C',
        action: 'handle_SoftCard',
        label: '',
        param2: {
          source: logInfo.source,
          source_p: logInfo.source_p,
          source_pp: logInfo.source_pp,
          cardName: 'SoftCardSearch',
          search_word: logInfo.search_word,
          search_type: logInfo.search_type,
          lenovo_bizinfo: logInfo.lenovo_bizinfo,
        },
        param3: soft.bizInfo,
      }),
    );
    dispatch(
      logPostInfo({
        source: logInfo.source,
        source_p: logInfo.source_p,
        source_pp: logInfo.source_pp,
        search_word: logInfo.search_word,
        search_type: logInfo.search_type,
        lenovo_bizinfo: logInfo.lenovo_bizinfo,
      }),
    );
  }, [dispatch]);

  /**
   * 点击安装或者升级  进入搜索结果页面
   */
  const handleSoftCardBtn = useCallback(
    softInfo => {
      const findInst = installedSofts.find(
        soft_ => soft_.softID === softInfo.softID || soft_.SoftID === softInfo.softID,
      );
      const findUpdate = upgradeSofts.find(
        soft_ => soft_.softID === softInfo.softID || soft_.SoftID === softInfo.softID,
      );

      // 即点击安装或者更新跳入搜索结果页
      if (!findInst || (findInst && findUpdate)) {
        dispatch(
          logPostInfo({
            source: logInfo.source,
            source_p: logInfo.source_p,
            source_pp: logInfo.source_pp,
            search_word: logInfo.search_word,
            search_type: logInfo.search_type,
            lenovo_bizinfo: logInfo.lenovo_bizinfo,
          }),
        );
        if (softInfo.androidType === '1') {
          history.push(
            `${CONTEXT}/searchresult?keyword=${encodeURIComponent(softInfo.softName)}&firstId=${
              softInfo.packageName
            }&androidType=${softInfo.androidType || '0'}&bizinfo=${encodeURIComponent(
              softInfo.serviceBizInfo,
            )}`,
          );
        } else {
          history.push(
            `${CONTEXT}/searchresult?keyword=${encodeURIComponent(softInfo.softName)}&firstId=${
              softInfo.softID
            }&androidType=${softInfo.androidType || '0'}&bizinfo=${encodeURIComponent(
              softInfo.serviceBizInfo,
            )}`,
          );
        }
      }
    },
    [dispatch, upgradeSofts, installedSofts],
  );

  useEffect(() => {
    if (logInfo.changeIndex === null && lenovoWords.kw === logInfo.search_word && firstapp) {
      dispatch(
        logging({
          category: 'I',
          action: 'Search_Lenovo_Firstapp',
          label: '',
          param2: {
            source: logInfo.source,
            search_type: 4,
            search_word: logInfo.search_word,
            lenovo_bizinfo: logInfo.lenovo_bizinfo,
            softid: soft.androidType === '1' ? soft.packageName : soft.softID,
            softName: soft.softName,
            softType: getSoftType(soft),
          },
          param3: soft.bizInfo,
        }),
      );
    }
    if (logInfo.changeIndex === null && lenovoWords.kw === logInfo.search_word && !firstapp) {
      dispatch(
        logging({
          category: 'I',
          action: 'Search_Lenovo_Nofirstapp',
          label: '',
          param2: {
            source: logInfo.source,
            search_type: 6,
            search_word: logInfo.search_word,
            lenovo_bizinfo: logInfo.lenovo_bizinfo,
            softid: soft.androidType === '1' ? soft.packageName : soft.softID,
            softName: soft.softName,
            softType: getSoftType(soft),
          },
          param3: soft.bizInfo,
        }),
      );
    }
  }, [dispatch, soft, lenovoWords, firstapp]);

  const onMouseOver = useCallback(e => {
    setMouseOver(1);
  }, []);
  const onMouseLeave = useCallback(e => {
    setMouseOver(2);
  }, []);

  const formatDiscount = (current, original) => {
    let cp = parseFloat(current);
    let op = parseFloat(original);
    if (cp > 0 && op > 0) {
      let discont = parseFloat((cp / op) * 10).toFixed(1);
      if (discont.indexOf('.0') > -1) {
        return discont.slice(0, discont.length - 2);
      }
      return discont;
    }
    return '0';
  };

  const formatPriceType3 = useCallback((num = '0') => {
    return parseFloat((num || '0')?.replace('¥', '').replace('￥', ''));
  }, []);

  return (
    <div
      className={styles.soft_card}
      onMouseOver={e => {
        onMouseOver(e);
      }}
      onMouseLeave={e => {
        onMouseLeave(e);
      }}
    >
      <Link
        className={styles.soft_card_img_box}
        to={{
          pathname:
            soft.androidType === '1'
              ? `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${
                  soft.bizInfo || '{}'
                }?isSearch=true`
              : `${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}?isSearch=true`,
        }}
        onClick={() => {
          handleSoftCard(soft);
        }}
      >
        <img className={styles.soft_card_img} src={soft.logoFile} alt="" />
        {soft.androidType === '1' && <div className={styles.soft_card_logo} />}
        <Link
          to={{
            pathname:
              soft.androidType === '1'
                ? `${CONTEXT}/adetail/${soft.packageName}/${soft.versionCode}/${
                    soft.bizInfo || '{}'
                  }?isSearch=true`
                : `${CONTEXT}/detail/soft/${soft.softID}/${soft.bizInfo || '{}'}?isSearch=true`,
          }}
          onClick={() => {
            handleSoftCard(soft);
          }}
        >
          <div
            className={styles.soft_card_title}
            dangerouslySetInnerHTML={{ __html: soft.softNameShow }}
            title={soft.keyWord}
          />
          <div className={styles.soft_card_desc}>{soft.downloadCount || 0}安装</div>
        </Link>
      </Link>
      <div className={styles.soft_card_box}>
        <div
          className={styles.soft_card_opt}
          onClick={e => {
            handleSoftCardBtn(soft);
          }}
        >
          {/* 当不是付费软件 payType===1 是付费软件  soft?.androidType === '3'并且没有价格信息是付费软件  */}
          {soft &&
            (!soft?.payType || soft?.payType !== 1) &&
            (soft?.androidType !== '3' ||
              (soft?.androidType === '3' &&
                !soft?.sourceInfo?.sellInfo?.currentPrice &&
                !soft?.sourceInfo?.sellInfo?.originalPrice)) && (
              <Button
                soft={soft}
                info={{
                  className: styles.soft_button,
                  className_busing: styles.soft_button_busing,
                  className_open: styles.soft_button_open,
                }}
                // 联系词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
                logInfo={{ ...logInfo, isSearch: true }}
              />
            )}

          {/* 当是付费软件 */}
          {((soft && soft?.payType === 1) ||
            (soft?.androidType === '3' &&
              (soft?.sourceInfo?.sellInfo?.currentPrice ||
                soft?.sourceInfo?.sellInfo?.originalPrice))) &&
            mouseOver === 1 && (
              <Button
                soft={soft}
                info={{
                  className: styles.soft_button,
                  className_busing: styles.soft_button_busing,
                  className_open: styles.soft_button_open,
                }}
                // 联系词softcard 做特殊处理  所以source_p, source_pp 通过父组件传入
                logInfo={{ ...logInfo, isSearch: true }}
              />
            )}
          {soft && soft?.payType === 1 && mouseOver !== 1 && (
            <div
              className={styles.soft_buyInfos}
              onClick={e => {
                e.stopPropagation();
              }}
            >
              {soft?.originalPrice &&
                soft?.currentPrice &&
                soft?.originalPrice !== soft?.currentPrice && (
                  <>
                    <div className={`soft_buyInfos_zk`}>
                      {formatDiscount(soft?.currentPrice, soft?.originalPrice)}折
                    </div>
                    <div className={`soft_buyInfos_price`}>
                      <div className={`soft_buyInfos_cp`}>
                        <span className={`soft_buyInfos_cp_1`}>￥</span>
                        <span className={`soft_buyInfos_cp_2`}>
                          {formatMoney(parseFloat((soft?.currentPrice || 0) / 100))}
                        </span>
                      </div>
                      <div className={`soft_buyInfos_op`}>
                        ￥{formatMoney(parseFloat((soft?.originalPrice || 0) / 100))}
                      </div>
                    </div>
                  </>
                )}

              {((!soft?.originalPrice && soft?.currentPrice) ||
                (soft?.originalPrice && !soft?.currentPrice) ||
                (soft?.originalPrice &&
                  soft?.currentPrice &&
                  soft?.originalPrice === soft?.currentPrice)) && (
                // {((!soft?.originalPrice && soft?.currentPrice) ||
                //   (soft?.originalPrice && !soft?.currentPrice)) && (
                <>
                  <div className={`soft_buyInfos_price`}>
                    <div className={`soft_buyInfos_cp`}>
                      <span className={`soft_buyInfos_cp_1`}>￥</span>
                      <span className={`soft_buyInfos_cp_2`}>
                        {formatMoney(
                          parseFloat((soft?.currentPrice || soft?.originalPrice || 0) / 100),
                        )}
                      </span>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
          {soft?.androidType === '3' &&
            (soft?.sourceInfo?.sellInfo?.currentPrice ||
              soft?.sourceInfo?.sellInfo?.originalPrice) &&
            mouseOver !== 1 && (
              <div
                className={styles.soft_buyInfos}
                onClick={e => {
                  e.stopPropagation();
                }}
              >
                {soft?.sourceInfo?.sellInfo?.discount && (
                  <div className={`soft_buyInfos_zk`}>
                    {soft?.sourceInfo?.sellInfo?.discount} 折
                  </div>
                )}
                {soft?.sourceInfo?.sellInfo?.currentPrice ===
                  soft?.sourceInfo?.sellInfo?.originalPrice && (
                  <>
                    {(soft?.sourceInfo?.sellInfo?.currentPrice &&
                      !soft?.sourceInfo?.sellInfo?.originalPrice) ||
                      (!soft?.sourceInfo?.sellInfo?.currentPrice &&
                        soft?.sourceInfo?.sellInfo?.originalPrice && (
                          <div className={`soft_buyInfos_price`}>
                            <div className="soft_buyInfos_cp">
                              <span className={`soft_buyInfos_cp_1`}>￥</span>
                              <span className={`soft_buyInfos_cp_2`}>
                                {formatPriceType3(
                                  soft?.sourceInfo?.sellInfo?.currentPrice ||
                                    soft?.sourceInfo?.sellInfo?.originalPrice,
                                )}
                              </span>
                            </div>
                          </div>
                        ))}
                    {soft?.sourceInfo?.sellInfo?.currentPrice &&
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <div className={`soft_buyInfos_price`}>
                          <div className={`soft_buyInfos_cp`}>
                            <span className={`soft_buyInfos_cp_1`}>￥</span>
                            <span className={`soft_buyInfos_cp_2`}>
                              {formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                            </span>
                          </div>
                        </div>
                      )}
                  </>
                )}
                {soft?.sourceInfo?.sellInfo?.currentPrice !==
                  soft?.sourceInfo?.sellInfo?.originalPrice && (
                  <>
                    {soft?.sourceInfo?.sellInfo?.currentPrice &&
                      !soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <div className={`soft_buyInfos_price`}>
                          <div className={`soft_buyInfos_cp`}>
                            <span className={`soft_buyInfos_cp_1`}>￥</span>
                            <span className={`soft_buyInfos_cp_2`}>
                              {formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                            </span>
                          </div>
                        </div>
                      )}
                    {!soft?.sourceInfo?.sellInfo?.currentPrice &&
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <div className={`soft_buyInfos_price`}>
                          <div className={`soft_buyInfos_cp`}>
                            <span className={`soft_buyInfos_cp_1`}>￥</span>
                            <span className={`soft_buyInfos_cp_2`}>
                              {formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}
                            </span>
                          </div>
                        </div>
                      )}
                    {soft?.sourceInfo?.sellInfo?.currentPrice &&
                      soft?.sourceInfo?.sellInfo?.originalPrice && (
                        <div className={`soft_buyInfos_price`}>
                          <div className={`soft_buyInfos_cp`}>
                            <span className={`soft_buyInfos_cp_1`}>￥</span>
                            <span className={`soft_buyInfos_cp_2`}>
                              {formatPriceType3(soft?.sourceInfo?.sellInfo?.currentPrice)}
                            </span>
                          </div>
                          <div className={`soft_buyInfos_op`}>
                            {`￥${formatPriceType3(soft?.sourceInfo?.sellInfo?.originalPrice)}`}
                          </div>
                        </div>
                      )}
                  </>
                )}
              </div>
            )}
        </div>
      </div>
    </div>
  );
});
